import { SET_TABLE_PATHS } from "../constants";

export const setTablePaths = (tablePaths) => ({
	type: SET_TABLE_PATHS,
	payload: tablePaths,
});
